import { GridColDef } from '@mui/x-data-grid';

import MuiDataGrid from 'components/MuiDataGrid';
import useI18n from 'hooks/useI18n';
import { TGender, TPublic } from './api/type';
import { IAdminPatients } from './api/type';

interface Props {
  list: IAdminPatients[];
  isLoading: boolean;
  totalCount: number;
  page: number;
  selected: string[];
  onSelected: (value: string[]) => void;
  onPageChange: (page: number) => void;
}

function ListBody(props: Props) {
  const i18n = useI18n();
  const {
    list,
    isLoading,
    totalCount,
    page,
    onPageChange,
    onSelected,
    selected,
  } = props;

  const columns: GridColDef[] = [
    { field: 'patient_virtual_id', headerName: '가상환자ID' },
    { field: 'name', headerName: '가상환자명', minWidth: 200 },
    { field: 'age', headerName: '나이' },
    {
      field: 'gender',
      headerName: '성별',
      valueFormatter: ({ value }: { value: TGender }) =>
        i18n(`GENDER.${value}`),
    },
    { field: 'department', headerName: '진료과' },
    { field: 'ward', headerName: '병동명' },
    { field: 'disease_main', headerName: '주진단코드' },
    {
      field: 'patient_private',
      headerName: '학생 ENR 공개여부',
      valueFormatter: ({ value }: { value: TPublic }) =>
        i18n(`PUBLIC.${value}`),
    },
  ];

  return (
    <MuiDataGrid
      columns={columns}
      loading={isLoading}
      onPageChange={onPageChange}
      onSelectionModelChange={models => {
        onSelected(models as string[]);
      }}
      page={page}
      pageSize={20}
      rows={list.map(item => ({
        ...item,
        id: item.patient_id,
        patient_virtual_id: item.patient_virtual_id ?? item.patient_id,
      }))}
      rowCount={totalCount}
      selectionModel={selected}
    />
  );
}

export default ListBody;
